import { createBrowserRouter } from "react-router";

import { ProtectedRoute } from "@/components/ProtectedRoute";
import { RootRedirect } from "@/components/RootRedirect";
import { EventPage } from "@/pages/EventPage/EventPage";
import { FriendsPage } from "@/pages/FriendsPage/FriendsPage";
import { NotificationsPage } from "@/pages/NotificationsPage/NotificationsPage";
import { OverviewPage } from "@/pages/OverviewPage/OverviewPage";
import { PrivacyPolicyPage } from "@/pages/PrivacyPolicyPage/PrivacyPolicyPage";
import { ProfileEventsPage } from "@/pages/ProfileEventsPage/ProfileEventsPage";
import { ProfilePage } from "@/pages/ProfilePage/ProfilePage";
import { ResetPasswordPage } from "@/pages/ResetPasswordPage/ResetPasswordPage";
import { SettingsPage } from "@/pages/SettingsPage/SettingsPage";
import { SplashPage } from "@/pages/SplashPage/SplashPage";
import { TermsOfServicePage } from "@/pages/TermsOfServicePage/TermsOfServicePage";
import { VerifyEmailPage } from "@/pages/VerifyEmailPage/VerifyEmailPage";

import { getTracer } from "./opentelemetry";

export const router = createBrowserRouter(
  [
    {
      path: "/",
      element: <RootRedirect />,
    },
    {
      path: "/terms-of-service",
      element: <TermsOfServicePage />,
    },
    {
      path: "/privacy-policy",
      element: <PrivacyPolicyPage />,
    },
    {
      path: "/overview",
      element: (
        <ProtectedRoute>
          <OverviewPage />
        </ProtectedRoute>
      ),
    },
    {
      path: "/friends",
      element: (
        <ProtectedRoute>
          <FriendsPage />
        </ProtectedRoute>
      ),
    },
    {
      path: "/profile/:accountId",
      element: (
        <ProtectedRoute>
          <ProfilePage />
        </ProtectedRoute>
      ),
    },
    {
      path: "/profile/:accountId/events",
      element: (
        <ProtectedRoute>
          <ProfileEventsPage />
        </ProtectedRoute>
      ),
    },
    {
      path: "/event/:eventId",
      element: <EventPage />,
    },
    {
      path: "/join",
      element: (
        <ProtectedRoute invert>
          <SplashPage />
        </ProtectedRoute>
      ),
    },
    {
      path: "/settings",
      element: (
        <ProtectedRoute>
          <SettingsPage />
        </ProtectedRoute>
      ),
    },
    {
      path: "/notifications",
      element: (
        <ProtectedRoute>
          <NotificationsPage />
        </ProtectedRoute>
      ),
    },
    {
      path: "/verify-email/:verificationId",
      element: <VerifyEmailPage />,
    },
    {
      path: "/reset-password/:resetId",
      element: <ResetPasswordPage />,
    },
  ],
  {
    instrumentations: [
      {
        router(router) {
          router.instrument({
            async navigate(navigate, { currentUrl, to }) {
              await getTracer().startActiveSpan(
                `navigate ${to}`,
                { attributes: { "navigation.from": currentUrl, "navigation.to": to } },
                async (span) => {
                  await navigate();
                  span.end();
                },
              );
            },
          });
        },
      },
    ],
  },
);
